import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

export default function ({ route, redirect }) {
  if (route.path === '/video-upscaler' && !featureFlagMixin.methods.isFeatureEnabled('video_upscaler_ai_tool')) {
    redirect('/');
  }
}
